const scroll = {
  state: {
    scroll: {}
  },
  mutations: {
    SET_ROUTE_SCROLL: (state, scroll) => {
      state.scroll[scroll.routeName] = scroll.scrollTop
    }
  },
  actions: {
    SetRouteScroll({ commit }, scroll) {
      commit('SET_ROUTE_SCROLL', scroll)
    }
  }
}
export default scroll



// WEBPACK FOOTER //
// ./src/store/modules/scroll.js